import styled from "styled-components";
import { Heading, Paragraph, Stack, constants } from "@thecb/components";

const { FONT_WEIGHT_SEMIBOLD, FONT_WEIGHT_REGULAR } = constants.styleConstants;

export const getCardBaseStyles = (theme, disabled, extraStyles) => `
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  flex-shrink: 0;
  padding: 24px;
  align-self: stretch;
  border-radius: 8px;
  text-decoration: none;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  line-height: inherit;
  background-color: ${
    disabled ? theme.disabledBackgroundColor : theme.backgroundColor
  };
  border: 1px solid
    ${disabled ? theme.disabledBorderColor : theme.borderColor};
  transition: all 0.2s ease-in-out;
  ${disabled ? `pointer-events: none;` : ""}
  ${extraStyles || ""}
`;

export const getCardHoverActiveStyles = (
  theme,
  disabled,
  hoverStyles,
  activeStyles
) => {
  if (disabled) {
    return `
      &:hover,
      &:active {
        cursor: default;
        box-shadow: none;
        border: 1px solid ${theme.disabledBorderColor};
      }
    `;
  }
  return `
    &:hover,
    &:active {
      cursor: pointer;
      box-shadow: 0px 0px 0px 0px rgba(41, 42, 51, 0.1),
        0px 5px 11px 0px rgba(41, 42, 51, 0.1),
        0px 4px 19px 0px rgba(41, 42, 51, 0.09),
        0px 27px 26px 0px rgba(41, 42, 51, 0.05),
        0px 56px 31px 0px rgba(41, 42, 51, 0.01),
        0px 80px 33px 0px rgba(41, 42, 51, 0);
    }
    ${hoverStyles || ""}

    &:hover:not(:active) {
      border: 1px solid ${theme.borderColor};
    }

    &:active {
      background-color: ${theme.activeBackgroundColor};
      border: 1px solid ${theme.borderColor};
      ${activeStyles || ""}
    }
  `;
};

export const Title = styled(Heading)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  line-height: 150%;
  background-color: transparent;
  font-weight: ${FONT_WEIGHT_SEMIBOLD};
  color: ${({ $disabled: disabled, $theme: theme }) =>
    disabled ? theme.disabledColor : theme.color};
`;

export const Subtitle = styled(Paragraph)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.14px;
  font-weight: ${FONT_WEIGHT_REGULAR};
  color: ${({ $disabled: disabled, $theme: theme }) =>
    disabled ? theme.disabledColor : theme.textColor};
`;

export const Footer = styled(Stack)`
  align-items: center;
  width: 100%;
`;
